import React, { useLayoutEffect } from "react";
import { observer } from "mobx-react-lite";
import { Center, chakra, Text } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { wenxinStore } from "@/thirdParty/wenxin/store";
import { genBlock } from "@/utils/bem";

import "./style.scss";
import GuideHighlight from "@/components/bussiness/GuideHighlight";
import { RadioTag } from "@/components/Radio/RadioTag";
import { MODEL_TYPES_INFO } from "../../constant";
import Icon from "@/components/Icon";
import { ReactComponent as HotSvg } from "@/assets/icons/hot.svg";

const block = genBlock("c-wenxin-highlight");
const WenxinHighLight: React.FC = () => {
  const { showHighlight } = wenxinStore;
  const lang = langStore.tgt;

  useLayoutEffect(() => {
    if (localStorage.getItem("onboarding") === "1") {
      setTimeout(() => {
        wenxinStore.openHighlight();
      }, 200);
    }
  }, []);

  function handleHide() {
    wenxinStore.setShowHighlight(false);
  }

  return (
    <GuideHighlight
      show={showHighlight}
      onHide={handleHide}
      storageKey="wenxin_highlighted"
      targetQuerySelector="#wenxin_TAG"
      tip={
        <>
          <Text>不想生成排队？</Text>
          <Text>可以使用百度文心 ERNIE-ViLG 模型来生成</Text>
          <Text>一次生成三张高清图，不用排队等待</Text>
        </>
      }
      className={block()}
    >
      <RadioTag
        variant="outline"
        __css={{
          minH: "24px",
          h: "fit-content",
          rounded: "4px",
          borderColor: "white",
          color: "white",
          display: "flex",
          alignItems: "center",
          cursor: "default",
          _hover: { color: "white", borderColor: "white" },
        }}
        id="wenxin_TAG"
      >
        {translate(MODEL_TYPES_INFO["wenxin"]?.label, lang)}
        {MODEL_TYPES_INFO["wenxin"]?.isHot ? (
          <Center h="14px">
            <Icon
              squared={false}
              w="64px"
              h="64px"
              p="6px"
              transition="all .3s cubic-bezier(.08,.52,.52,1)"
              mt="2px"
              ml="-2px"
              mr="-4px"
              svg={HotSvg}
            />
          </Center>
        ) : null}
      </RadioTag>
    </GuideHighlight>
  );
};

export default observer(WenxinHighLight);
